import { DateRanges } from "@models/shared";
import {
    startOfToday, startOfTomorrow, startOfYesterday, startOfWeek,
    endOfToday, endOfTomorrow, endOfYesterday, endOfWeek, startOfMonth, endOfMonth,
} from "date-fns";

export function getTzShiftString(shift?: number): string {
    if (!shift) {
        shift = 0;
    }
    shift += 0;
    const m = Math.abs(shift) % 60;
    const h = Math.trunc(Math.abs(shift) / 60).toString();
    return 'UTC' + (shift < 0 ? '-' : '+') + h + ':' + ('0' + m).slice(-2);
}

export function getYMD(dt: Date, def: string = '---'): string {
    let res = def;
    try {
        res = dt.getFullYear() + '-' + String(dt.getMonth() + 1).padStart(2, '0') + '-' + String(dt.getDate()).padStart(2, '0');
    }
    catch(e) {}
    return res;
}

export function getDMY(dt: Date): string {
    let res = 'N/A';
    try {
        res =  String(dt.getDate()).padStart(2, '0') + '.' + String(dt.getMonth() + 1).padStart(2, '0') + '.' + dt.getFullYear();
    }
    catch(e) {}
    return res;
}

export function getDateRanges(): DateRanges {
    const dt = new Date();
    return {
        yesterday: {
            start: startOfYesterday(),
            end: endOfYesterday(),
        },
        today: {
            start: startOfToday(),
            end: endOfToday(),
        },
        tomorrow: {
            start: startOfTomorrow(),
            end: endOfTomorrow(),
        },
        week: {
            start: startOfWeek(dt, { weekStartsOn: 1 }),
            end: endOfWeek(dt, { weekStartsOn: 1 }),
        },
        month: {
            start: startOfMonth(dt),
            end: endOfMonth(dt),
        },
    };
}

export function isValidDate(v: any): Date | undefined {
    if (v == null) {
        return;
    }
    const dt = new Date(v);
    return isNaN(dt.getTime()) ? undefined : dt;
}

export const HOLYDAYS: { [day: string]: boolean | undefined } = {
    '1.1.2020':   true,
    '2.1.2020':   true,
    '3.1.2020':   true,
    '6.1.2020':   true,
    '7.1.2020':   true,
    '8.1.2020':   true,
    '24.2.2020':  true,
    '1.5.2020':   true,
    '4.5.2020':   true,
    '5.5.2020':   true,
    '11.5.2020':  true,
    '12.6.2020':  true,
    '4.11.2020':  true,

    '1.1.2021':   true,
    '4.1.2021':   true,
    '5.1.2021':   true,
    '6.1.2021':   true,
    '7.1.2021':   true,
    '8.1.2021':   true,
    '20.2.2021':  false,
    '22.2.2021':  true,
    '23.2.2021':  true,
    '8.3.2021':   true,
    '3.5.2021':   true,
    '10.5.2021':  true,
    '14.6.2021':  true,
    '1.11.2021':  true,
    '2.11.2021':  true,
    '3.11.2021':  true,
    '4.11.2021':  true,
    '5.11.2021':  true,
    '31.12.2021': true,

    '3.1.2022':   true,
    '4.1.2022':   true,
    '5.1.2022':   true,
    '6.1.2022':   true,
    '7.1.2022':   true,
    '23.2.2022':  true,
    '5.3.2022':   false,
    '7.3.2022':   true,
    '8.3.2022':   true,
    '2.5.2022':   true,
    '3.5.2022':   true,
    '9.5.2022':   true,
    '10.5.2022':  true,
    '13.6.2022':  true,
    '4.11.2022':  true,

    '2.1.2023':   true,
    '3.1.2023':   true,
    '4.1.2023':   true,
    '5.1.2023':   true,
    '6.1.2023':   true,
    '23.2.2023':  true,
    '24.2.2023':  true,
    '8.3.2023':   true,
    '1.5.2023':   true,
    '8.5.2023':   true,
    '9.5.2023':   true,
    '12.6.2023':  true,
    '6.11.2023':  true,

    '1.1.2024':   true,
    '2.1.2024':   true,
    '3.1.2024':   true,
    '4.1.2024':   true,
    '5.1.2024':   true,
    '8.1.2024':   true,
    '23.2.2024':  true,
    '8.3.2024':   true,
    '27.4.2024':  false,
    '29.4.2024':  true,
    '30.4.2024':  true,
    '1.5.2024':   true,
    '9.5.2024':   true,
    '10.5.2024':  true,
    '12.6.2024':  true,
    '2.11.2024':  false,
    '4.11.2024':  true,
    '28.12.2024': false,
    '30.12.2024': true,
    '31.12.2024': true,

    '1.1.2025':   true,
    '2.1.2025':   true,
    '3.1.2025':   true,
    '6.1.2025':   true,
    '7.1.2025':   true,
    '8.1.2025':   true,
    '1.5.2025':   true,
    '2.5.2025':   true,
    '8.5.2025':   true,
    '9.5.2025':   true,
    '12.6.2025':  true,
    '13.6.2025':  true,
    '3.11.2025':  true,
    '4.11.2025':  true,
    '31.12.2025': true,

    '1.1.2026':   true,
    '2.1.2026':   true,
    '5.1.2026':   true,
    '6.1.2026':   true,
    '7.1.2026':   true,
    '8.1.2026':   true,
    '23.2.2026':  true,
    '9.3.2026':   true,
    '1.5.2026':   true,
    '4.5.2026':   true,
    '5.5.2026':   true,
    '11.5.2026':  true,
    '12.6.2026':  true,
    '4.11.2026':  true,
};
